<div class="form-group mb-2 mb-md-0 mr-2 date-range-field">
    <label class="mb-1" for="flow_tracking_range">Date range</label>
    <div class="date-range-control">
        <i class="feather feather-calendar date-range-icon" aria-hidden="true"></i>
        <input id="flow_tracking_range" type="text" class="form-control form-control-sm date-range-input"
            ngxDaterangepickerMd [(ngModel)]="selected" name="selected" startKey="start" endKey="end"
            [showCustomRangeLabel]="true" [alwaysShowCalendars]="true" [customRangeDirection]="true" [autoApply]="false"
            [ranges]="ranges" [linkedCalendars]="true" [showClearButton]="false" [showCancel]="true" [opens]="'left'"
            [drops]="'down'"
            [locale]="{ displayFormat: 'DD MMM YYYY', separator: ' - ', cancelLabel: 'Cancel', applyLabel: 'Apply' }"
            placeholder="Select date range" aria-label="Date range" (click)="syncPickerOpenState()">
        <div #rangeActions class="ft-range-actions" [class.is-visible]="pickerOpen" role="group"
            aria-label="Date range actions">
            <button type="button" class="btn btn-sm ft-btn-cancel" (click)="cancelDateRange($event)">Cancel</button>
            <button type="button" class="btn btn-sm btn-primary ft-btn-apply"
                (click)="applyDateRange($event)">Apply</button>
        </div>
    </div>
</div>